import {
  SET_COMMON_CONFIG,
  SET_MULTI_COMMON_CONFIG
} from "./actionTypes"

export const setCommonConfig = response => {
  return {
    type: SET_COMMON_CONFIG,
    payload: response,
  }
}

export const setMultiCommonConfig = response => {
  return {
    type: SET_MULTI_COMMON_CONFIG,
    payload: response,
  }
}